import cn from 'classnames'
import * as React from 'react'
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl'

import DoodleBackground from '../../../../components/doodle-background'
import { Row, Column } from '../../../../components/layout-row'
import Textblock from '../../../../components/textblock'
import { CheckIcon } from '../../../../components/icon'

import styles from './branch-leading.module.scss'

const BranchLeading = ({ inverted }: { inverted?: boolean }) => (
  <div className={cn(styles.root, inverted && styles.inverted)}>
    <h2 className={styles.title}>
      <FormattedHTMLMessage
        defaultMessage={`
        <span class="block-sm">Vi&nbsp;leder branchen framåt.</span>
        <span class="block-sm">Tillsammans kommer vi förändra&nbsp;allt.</span>
        `}
        id="about.branch-leading.title"
      />
    </h2>
    <Row>
      <Column first limitWidth>
        <Textblock
          description={
            <FormattedMessage
              defaultMessage="Bakom Dooer står samma team som skapade Loopia och Pingdom. Sveriges största webbhotell med över 200.000 kunder och världens största monitoreringstjänst för webbsidor med mer än 800.000 kunder. Företag som utmanat, förändrat och förbättrat sina branscher både här i&nbsp;Sverige och runt&nbsp;om&nbsp;i&nbsp;världen."
              id="about.branch-leading.done-before-description"
            />
          }
          title={
            <>
              <CheckIcon active className={styles.icon} />
              <FormattedMessage defaultMessage="Vi har gjort det förr." id="about.branch-leading.done-before-title" />
            </>
          }
        />
      </Column>
      <Column limitWidth>
        <Textblock
          description={
            <FormattedMessage
              defaultMessage="Bokföringen kommer bli helt automatiserad. Det vet vi. Vi kommer fortsätta påverka lagstiftare, leda integrering mellan branscher och utveckla smart teknik som skapar realtidsinsikter. Bokföringen som vi känner till den idag kommer förändras i grunden. Du som kund hos Dooer kommer få vara med på resan mot&nbsp;framtiden. Häng&nbsp;med!"
              id="about.branch-leading.doing-description"
            />
          }
          title={
            <>
              <CheckIcon active className={styles.icon} />
              <FormattedMessage defaultMessage="Vi kommer göra det igen." id="about.branch-leading.doing-title" />
            </>
          }
        />
      </Column>
    </Row>
    <DoodleBackground variant="bottomLeft" />
  </div>
)

export default BranchLeading
